import React from "react";
 
const IronBank = ()=> {
  return (
    <div>
      <h5>Iron Bank</h5>
      <blockquote>
        0x5f5Cd91070960D13ee549C9CC47e7a4Cd00457bb: <br/>
        We classify this debt as undercollateralized borrowing given that the debt is regularly serviced with repayment and collateral. <br/>
        This debt was the result of the Alpha Homora v1 exploit in February 2021, but all relevant parties were able to recover from it. <br/>
        Iron Bank and Alpha Homora v2 continue to operate on Ethereum, Avalanche, and Fantom, with new products and chain launches on the way. <br/>
        
        0xcDDBA405f8129e5bAe101045aa45aCa11C03b1c8 will be bad debt, once liquidations/repayment takes place. <br/>
        As part of best practices to maintain stability and accountability, Iron Bank will pay down this bad debt with protocol fees. <br/>

        <footer>
          <cite>- Iron Bank Team</cite>
        </footer>
      </blockquote>
    </div>
  )
}

export default IronBank
